define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/cdr/applications/{0}/{1}/validated',
		url: function () {
			let retUrl = this.urlRoot;

			if (this.instrumentId && this.instrumentId > 0) {
				retUrl += '/instrument/' + this.instrumentId;
			}

			return retUrl;
		},
		//sync fires right before a service call. we'll use this to remove the bind on a grid as detail page.
		//grids as detail pages basically use a fake bind to manage teh grid in rhythm. this results in us trying to save detail page data like
		// $InforClient.detailPageFamily.DetailPageName:{
		// 	fakeGridName: [
		// 		{ rowKyey: 0, rowValue: "xyz" },
		// 		{ rowKyey: 1, rowValue: "123" }
		// 	]
		// }
		//What we REALLY need to save however is this:
		// $InforClient.detailPageFamily.DetailPageName: [
		// 	{ rowKyey: 0, rowValue: "xyz" },
		// 	{ rowKyey: 1, rowValue: "123" }
		// ]
		//Since rhythm needs fakeGridName in order to function, and the server needs it to not be there, we'll remove it JUST before it's sent to the server.

		sync: function (method, model, options) {
			if (method == 'create' || method == 'update') {
				var madeChange = false;
				var modelJSON = model.toJSON();
				if (modelJSON.details) {
					$.each(modelJSON.details, (index, el) => {
						var keys = _.keys(el);
						//the data is stored in an attribute like $InforClient.Liferay7Test.liferay7Test or something similar. if we don't find that, we don't have data to save
						if (keys && keys.length > 0) {
							var agencyKey = _.find(keys, k => {
								return k.startsWith('$')
							});
							if (agencyKey) {
								var actualData = el[agencyKey];
								if (actualData) {
									if (actualData.thisIsAGridSoRemoveTheBind === true) {
										delete actualData.thisIsAGridSoRemoveTheBind
										madeChange = true;
									}
									var gridBind = _.keys(actualData);
									if (gridBind.length == 1) {
										modelJSON.details[index][agencyKey] = actualData[gridBind[0]];
									}
								}
							}
						}
					});
					if (madeChange === true) {
						model.set(modelJSON, { silent: true });
					}
				}
			}
			return Backbone.sync(method, model, options);
		}
	});
});
